import { render, staticRenderFns } from "./labelConfig.vue?vue&type=template&id=3d7984e0&scoped=true"
import script from "./labelConfig.vue?vue&type=script&lang=js"
export * from "./labelConfig.vue?vue&type=script&lang=js"
import style0 from "./labelConfig.vue?vue&type=style&index=0&id=3d7984e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7984e0",
  null
  
)

export default component.exports